import React from 'react';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import type { EntryPointReferenceSubject } from '@atlassian/jira-entry-point/src/controllers/utils/use-entry-point-load-manager/index.tsx';
import type { SoftwareWorkSuggestionsYourWorkEntryPoint } from '@atlassian/jira-software-work-suggestions-your-work/entrypoint.tsx';
import { EndInteractionsTracker } from '../../../common/utils.tsx';

import {
	WORK_SUGGESTIONS_TAB_KEY,
	SUCCESS_STATE,
	ERROR_STATE,
} from '../../../common/constants/tab-content.tsx';

// This uses TabProps to match the other tabs, which is why it's called maxItems instead of itemsPerPage here
export const WorkSuggestionsTab = ({
	entryPointReferenceSubject,
}: {
	entryPointReferenceSubject: EntryPointReferenceSubject<
		typeof SoftwareWorkSuggestionsYourWorkEntryPoint
	>;
}): React.JSX.Element => {
	// TODO is it a problem that LoadingState always assumes there is data here?
	return (
		<JiraEntryPointContainer
			id="renderWorkSuggestionsTabYourWork"
			packageName="jiraSoftwareWorkSuggestionsYourWork"
			teamName="jolt"
			entryPointReferenceSubject={entryPointReferenceSubject}
			errorFallback={() => (
				<>
					{/* TODO: Add a Error state */}
					<EndInteractionsTracker
						transitionKey={WORK_SUGGESTIONS_TAB_KEY}
						renderState={ERROR_STATE}
					/>
				</>
			)}
			fallback={null}
			runtimeProps={{
				onLoadedRenderSuccess: () => (
					<EndInteractionsTracker
						transitionKey={WORK_SUGGESTIONS_TAB_KEY}
						renderState={SUCCESS_STATE}
					/>
				),
			}}
		/>
	);
};
